function SendIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 24"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.76 21l20.99-9L2.76 3l-.01 7 15 2-15 2 .01 7z" />
    </svg>
  )
}

export default SendIcon
